import { trackClickAndReserveEvent } from '../tracking/trackingLayer';

const templateElement = document.getElementById('online-reservation-link-template');

export default {
  template: templateElement ? templateElement.innerHTML : '',
  props: {
    articleId: {
      type: String,
      required: true,
    },
    isSizeSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props) {
    const openLayer = () => {
      const detail = { articleId: props.articleId, isSizeSelected: props.isSizeSelected };
      document.dispatchEvent(new CustomEvent('ents:online-reservation:open', { detail }));
      // kept for external consumers (e.g. Wishlist)
      document.dispatchEvent(new CustomEvent('ents:hva-modal:open', { detail }));
      trackClickAndReserveEvent();
    };

    return { openLayer };
  },
};
